"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAscendingGroupRecuriveQuery = exports.getClosestItemTypeToGroupNestedAscendingQueryDef = exports.getItemTypeToGroupNestedAscendingQueryDef = void 0;
const iotv_v3_types_1 = require("@iotv/iotv-v3-types");
const debug_1 = require("../util/lambda/debug");
const edgeTypeMatrixFns_1 = require("../classDependentTypes/EdgeTypes/edgeTypeMatrixFns");
const BranchingQueryDefinition_1 = require("../util/dynamodb/GraphQuery/BranchingQueryDefinition");
const EdgeTypeMatrix_1 = require("../classDependentTypes/EdgeTypes/EdgeTypeMatrix");
const debug = debug_1.DEBUG_OVERRIDE || (debug_1.NOT_LAMBDA && false);
/** a development by-product */
/** returns type if all items of same time if not throws  error*/
const getUniqueObjectTypeId = (items) => {
    /** ensures every item is the type to be used  */
    const itemType = items.reduce((a, c) => {
        const thisType = c.type;
        if (a && a !== thisType) {
            throw new Error(`More that one item type included in list`);
        }
        else {
            a = thisType;
        }
        return a;
    }, undefined);
    return itemType;
};
const getItemTypeToGroupNestedAscendingQueryDef = ({ groupDefiningObjectTypeId, sourceItemType, addIdPrefixes = true, finalSubQueries = [], }) => {
    const idPrefix = addIdPrefixes ? `${sourceItemType}-${sourceItemType}-${iotv_v3_types_1.Traversal.ASCENDING}-` : '';
    const groupToGroupDefiningType = [
        { objectTypeId: groupDefiningObjectTypeId, adjacencyType: iotv_v3_types_1.AdjacentType.PARENT, edgeTypeId: (0, edgeTypeMatrixFns_1.getParentEdgeTypeId)('Group', groupDefiningObjectTypeId) },
    ];
    const groupToGroupDefiningTypeQuery = new BranchingQueryDefinition_1.BranchingQueryDefinition({
        id: `${idPrefix}groupToGroupDefiningTypeQuery`,
        path: groupToGroupDefiningType,
        subQueries: finalSubQueries,
    });
    const groupDefiningTypeToGroup = [
        { objectTypeId: 'Group', adjacencyType: iotv_v3_types_1.AdjacentType.PARENT, edgeTypeId: (0, edgeTypeMatrixFns_1.getParentEdgeTypeId)(sourceItemType, 'Group') },
    ];
    const groupDefiningTypeToGroupQuery = new BranchingQueryDefinition_1.BranchingQueryDefinition({
        id: `${idPrefix}groupDefiningTypeToGroupQuery`,
        path: groupDefiningTypeToGroup,
        subQueries: [],
    });
    const groupToGroup = [
        { objectTypeId: 'Group', adjacencyType: iotv_v3_types_1.AdjacentType.PARENT, edgeTypeId: EdgeTypeMatrix_1.edgeTypeMatrix.Group.Group.group_has_subGroup.edgeTypeId },
    ];
    const groupToGroupQuery = new BranchingQueryDefinition_1.BranchingQueryDefinition({
        id: `${idPrefix}groupToGroupQuery`,
        path: groupToGroup,
        subQueries: [groupToGroupDefiningTypeQuery],
    });
    groupToGroupQuery.addSubQuery(groupToGroupQuery);
    groupToGroupDefiningTypeQuery.addSubQuery(groupDefiningTypeToGroupQuery);
    groupDefiningTypeToGroupQuery.addSubQuery(groupToGroupDefiningTypeQuery);
    groupDefiningTypeToGroupQuery.addSubQuery(groupToGroupQuery);
    const subjectQuery = [{ objectTypeId: sourceItemType, adjacencyType: iotv_v3_types_1.AdjacentType.SUBJECT }];
    const itemsToGroupQuery = new BranchingQueryDefinition_1.BranchingQueryDefinition({
        path: subjectQuery,
        subQueries: [groupDefiningTypeToGroupQuery, groupToGroupDefiningTypeQuery],
        id: `${idPrefix}itemTypeToGroupNestedAscendingQueryBase`,
    });
    return itemsToGroupQuery;
};
exports.getItemTypeToGroupNestedAscendingQueryDef = getItemTypeToGroupNestedAscendingQueryDef;
/**
 * Gets path from `sourceItem` -> `source Item group` -> `...` -> `source Item Group` -> `GroupDefiningObject`
 *
 * Stops when it hits the first group defining object.
 * Useful when you want to find the nearest ascending item, but go no further:
 *
 * E.g. User -> Relevant Customer
 *
 * Final Sub Queries allows subqueries to be injected into the final query of group -> groupDefiningType, so you can chain them like normal
 */
const getClosestItemTypeToGroupNestedAscendingQueryDef = ({ groupDefiningObjectTypeId, sourceItemType, addIdPrefixes = true, finalSubQueries = [], }) => {
    const idPrefix = addIdPrefixes ? `${sourceItemType}-${sourceItemType}-${iotv_v3_types_1.Traversal.ASCENDING}-` : '';
    // There are a rare few objects that go straight from themselves to customer (e.g. property). This query lets those objects to be inputs
    const sourceToDefiningTypeQuery = new BranchingQueryDefinition_1.BranchingQueryDefinition({
        id: `${idPrefix}sourceToDefiningTypeQuery`,
        path: [
            {
                objectTypeId: groupDefiningObjectTypeId,
                adjacencyType: iotv_v3_types_1.AdjacentType.PARENT,
                edgeTypeId: (0, edgeTypeMatrixFns_1.getParentEdgeTypeId)(sourceItemType, groupDefiningObjectTypeId),
            },
        ],
        subQueries: [],
    });
    const groupToGroupDefiningTypeQuery = new BranchingQueryDefinition_1.BranchingQueryDefinition({
        id: `${idPrefix}groupToGroupDefiningTypeQuery`,
        path: [
            { objectTypeId: groupDefiningObjectTypeId, adjacencyType: iotv_v3_types_1.AdjacentType.PARENT, edgeTypeId: (0, edgeTypeMatrixFns_1.getParentEdgeTypeId)('Group', groupDefiningObjectTypeId) },
        ],
        subQueries: finalSubQueries,
    });
    const groupToGroupQuery = new BranchingQueryDefinition_1.BranchingQueryDefinition({
        id: `${idPrefix}groupToGroupQuery`,
        path: [{ objectTypeId: 'Group', adjacencyType: iotv_v3_types_1.AdjacentType.PARENT, edgeTypeId: EdgeTypeMatrix_1.edgeTypeMatrix.Group.Group.group_has_subGroup.edgeTypeId }],
        subQueries: [groupToGroupDefiningTypeQuery],
    });
    groupToGroupQuery.addSubQuery(groupToGroupQuery);
    const itemsToGroupQuery = new BranchingQueryDefinition_1.BranchingQueryDefinition({
        path: [{ objectTypeId: 'Group', adjacencyType: iotv_v3_types_1.AdjacentType.PARENT, edgeTypeId: (0, edgeTypeMatrixFns_1.getParentEdgeTypeId)(sourceItemType, 'Group') }],
        subQueries: [groupToGroupDefiningTypeQuery, groupToGroupQuery],
        id: `${idPrefix}itemsToGroup`,
    });
    // Start with myself so the source can be a group too
    const closestAscendingApexQuery = new BranchingQueryDefinition_1.BranchingQueryDefinition({
        id: `${idPrefix}itemTypeToGroupNestedAscendingQueryBase`,
        path: [{ objectTypeId: sourceItemType, adjacencyType: iotv_v3_types_1.AdjacentType.SUBJECT }],
        subQueries: [itemsToGroupQuery, groupToGroupQuery, groupToGroupDefiningTypeQuery, sourceToDefiningTypeQuery],
    });
    return closestAscendingApexQuery;
};
exports.getClosestItemTypeToGroupNestedAscendingQueryDef = getClosestItemTypeToGroupNestedAscendingQueryDef;
/** returns branching query definition that can be used in (datastore) getBranchingQueryDefinitionResults and will return a nodeEdgeMapper containing the upwards path via Groups and groupDefiningTypeId */
const getAscendingGroupRecuriveQuery = ({ groupDefiningObjectTypeId, item }) => {
    const query = {
        topLevelQuery: (0, exports.getItemTypeToGroupNestedAscendingQueryDef)({ groupDefiningObjectTypeId, sourceItemType: item.type }),
        contextObjects: [item],
    };
    return query;
};
exports.getAscendingGroupRecuriveQuery = getAscendingGroupRecuriveQuery;
